// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Person } from './person';
import { UserRole } from './user-role';

/// <code-import> Place custom imports between <code-import> tags
import _ from 'lodash';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class User extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  //TODO: remove
    Code: any;
    jwtToken: string;

    get displayRoles() {
        let roles: string[] = [];
        if (!!this.userRoles) {
            const userRoles = _(this.userRoles).orderBy('role.name');
            userRoles.forEach((x) => {
                roles.push(x.role.name);
            });
        }
        return roles.join(' ---- ');
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  email?: string;
  inactive!: boolean;
  name?: string;
  password?: string;
  personId?: number;
  userName?: string;
  person!: Person;
  userRoles!: UserRole[];
}

